import type { EconomicsItem } from '@/services/registration';
import type { PriceCompute } from './types';

// Matches RegistrationPriceAuthority.ResolveComputedSpecialOptionLine.
export const refundablePercentOfCart: PriceCompute = (option, { baseTotal }) => {
  const percent = option.price ?? 0;
  return percent > 0 && baseTotal > 0 ? Math.round(baseTotal * percent) / 100 : 0;
};

// Líneas que forman la base de una special con precio derivado: fuera la comisión agregada, el envío de
// dorsal (un servicio aparte) y las propias specials de `excludedQuestionIds`. El cupón queda fuera salvo
// `keepVoucher` (el importe protegido del widget dinámico sí lo descuenta). Pareado con la base del BKD.
export function specialBaseLines(
  economics: EconomicsItem[],
  excludedQuestionIds: ReadonlySet<number> = new Set(),
  { keepVoucher = false }: { keepVoucher?: boolean } = {},
): EconomicsItem[] {
  return economics.filter(line =>
    !('_isCommission' in line)
    && (keepVoucher || !('_isVoucher' in line))
    && !('isBibShipping' in line && line.isBibShipping)
    && (!('questionId' in line) || line.questionId == null || !excludedQuestionIds.has(line.questionId)));
}

export function getSpecialBaseTotal(
  economics: EconomicsItem[],
  excludedQuestionIds: ReadonlySet<number> = new Set(),
): number {
  return specialBaseLines(economics, excludedQuestionIds)
    .reduce((total, line) => total + (line.price ?? 0) * (line.quantity ?? 0), 0);
}
